
import React from 'react';

export default () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
            <defs>
                <clipPath id="b">
                    <rect width="30" height="30"/>
                </clipPath>
            </defs>
            <g id="a" clipPath="url(#b)">
                <g transform="translate(-244 -3254.61)">
                    <g transform="translate(269.439 3269.836) rotate(180)" fill="none">
                        <path d="M10.72,0A10.982,10.982,0,0,1,21.44,11.227H0A10.982,10.982,0,0,1,10.72,0Z" stroke="none"/>
                        <path d="M 10.71975994110107 1.099997520446777 C 5.768299102783203 1.099997520446777 1.678609848022461 5.058222770690918 1.15635871887207 10.12699794769287 L 20.28316116333008 10.12699794769287 C 19.76091003417969 5.058222770690918 15.67122077941895 1.099997520446777 10.71975994110107 1.099997520446777 M 10.71975994110107 -1.9073486328125e-06 C 16.6401195526123 -1.9073486328125e-06 21.43951988220215 5.026497840881348 21.43951988220215 11.22699737548828 L 0 11.22699737548828 C 0 5.026497840881348 4.799400329589844 -1.9073486328125e-06 10.71975994110107 -1.9073486328125e-06 Z" stroke="none" fill="#1f1f1f"/>
                    </g>
                    <path d="M0,0H15.835" transform="translate(250.847 3280)" fill="none" stroke="#1f1f1f" strokeWidth="1.1"/>
                    <path d="M.029-.033c-.371-2.8,4.335-2.581,4.024,0" transform="translate(256.492 3279.752)" fill="none" stroke="#1f1f1f" strokeWidth="1.1"/>
                    <line y2="8.5" transform="translate(258.5 3269.5)" fill="none" stroke="#1f1f1f" strokeWidth="1.1"/>
                </g>
            </g>
        </svg>
);
}